module.exports = __webpack_public_path__ + "static/media/6P.e5709553.svg";